import React from 'react';

import { useTranslation } from '@/src/i18n';
import TLCFilter from './TLCFilter';

type Props = {
  filters: Record<string, any>;
  selectValue: (filter: Record<string, any>) => void;
};
const TLCFeeFilter = ({ selectValue, filters }: Props) => {
  const { t } = useTranslation();
  const extraFeeOptions = [
    {
      label: t('no_extra_fees'),
      value: 'DISALLOW',
      subLabel: t('convention_sector_1'),
    },
    {
      label: t('all_fees'),
      value: 'ALL',
      subLabel: t('convention-all-sectors-and-no-convention'),
    },
  ];

  const updateExtraFee = (value?: string) => {
    selectValue({ extraFeeFilter: value });
  };

  const resetValue = () => {
    selectValue({ extraFeeFilter: undefined });
  };

  return (
    <TLCFilter
      updateValue={updateExtraFee}
      resetValue={resetValue}
      selectedValue={filters.extraFeeFilter}
      options={extraFeeOptions}
      placeholder={t('fees')}
    />
  );
};

export default TLCFeeFilter;
